/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(37);


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	!function(global, factory) {
	     true ? factory(exports) : 'function' == typeof define && define.amd ? define([ 'exports' ], factory) : factory(global.preact = global.preact || {});
	}(this, function(exports) {
	    function VNode(nodeName, attributes, children) {
	        this.nodeName = nodeName;
	        this.attributes = attributes;
	        this.children = children;
	        this.key = attributes && attributes.key;
	    }
	    function h(nodeName, attributes) {
	        var children, lastSimple, child, simple, i;
	        for (i = arguments.length; i-- > 2; ) stack.push(arguments[i]);
	        if (attributes && attributes.children) {
	            if (!stack.length) stack.push(attributes.children);
	            delete attributes.children;
	        }
	        while (stack.length) if ((child = stack.pop()) instanceof Array) for (i = child.length; i--; ) stack.push(child[i]); else if (null != child && child !== !0 && child !== !1) {
	            if ('number' == typeof child) child = String(child);
	            simple = 'string' == typeof child;
	            if (simple && lastSimple) children[children.length - 1] += child; else {
	                (children || (children = [])).push(child);
	                lastSimple = simple;
	            }
	        }
	        var p = new VNode(nodeName, attributes || void 0, children || EMPTY_CHILDREN);
	        if (options.vnode) options.vnode(p);
	        return p;
	    }
	    function extend(obj, props) {
	        if (props) for (var i in props) obj[i] = props[i];
	        return obj;
	    }
	    function clone(obj) {
	        return extend({}, obj);
	    }
	    function delve(obj, key) {
	        for (var p = key.split('.'), i = 0; i < p.length && obj; i++) obj = obj[p[i]];
	        return obj;
	    }
	    function isFunction(obj) {
	        return 'function' == typeof obj;
	    }
	    function isString(obj) {
	        return 'string' == typeof obj;
	    }
	    function hashToClassName(c) {
	        var str = '';
	        for (var prop in c) if (c[prop]) {
	            if (str) str += ' ';
	            str += prop;
	        }
	        return str;
	    }
	    function cloneElement(vnode, props) {
	        return h(vnode.nodeName, extend(clone(vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
	    }
	    function createLinkedState(component, key, eventPath) {
	        var path = key.split('.');
	        return function(e) {
	            var t = e && e.target || this, state = {}, obj = state, v = isString(eventPath) ? delve(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e, i = 0;
	            for (;i < path.length - 1; i++) obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
	            obj[path[i]] = v;
	            component.setState(state);
	        };
	    }
	    function enqueueRender(component) {
	        if (!component._dirty && (component._dirty = !0) && 1 == items.push(component)) (options.debounceRendering || defer)(rerender);
	    }
	    function rerender() {
	        var p, list = items;
	        items = [];
	        while (p = list.pop()) if (p._dirty) renderComponent(p);
	    }
	    function isFunctionalComponent(vnode) {
	        var nodeName = vnode && vnode.nodeName;
	        return nodeName && isFunction(nodeName) && !(nodeName.prototype && nodeName.prototype.render);
	    }
	    function buildFunctionalComponent(vnode, context) {
	        return vnode.nodeName(getNodeProps(vnode), context || EMPTY);
	    }
	    function isSameNodeType(node, vnode) {
	        if (isString(vnode)) return node instanceof Text;
	        if (isString(vnode.nodeName)) return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	        if (isFunction(vnode.nodeName)) return (node._componentConstructor ? node._componentConstructor === vnode.nodeName : !0) || isFunctionalComponent(vnode); else return;
	    }
	    function isNamedNode(node, nodeName) {
	        return node.normalizedNodeName === nodeName || toLowerCase(node.nodeName) === toLowerCase(nodeName);
	    }
	    function getNodeProps(vnode) {
	        var props = clone(vnode.attributes);
	        props.children = vnode.children;
	        var defaultProps = vnode.nodeName.defaultProps;
	        if (defaultProps) for (var i in defaultProps) if (void 0 === props[i]) props[i] = defaultProps[i];
	        return props;
	    }
	    function removeNode(node) {
	        var p = node.parentNode;
	        if (p) p.removeChild(node);
	    }
	    function setAccessor(node, name, old, value, isSvg) {
	        if ('className' === name) name = 'class';
	        if ('class' === name && value && 'object' == typeof value) value = hashToClassName(value);
	        if ('key' === name) ; else if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
	            if (!value || isString(value) || isString(old)) node.style.cssText = value || '';
	            if (value && 'object' == typeof value) {
	                if (!isString(old)) for (var i in old) if (!(i in value)) node.style[i] = '';
	                for (var i in value) node.style[i] = 'number' == typeof value[i] && !NON_DIMENSION_PROPS[i] ? value[i] + 'px' : value[i];
	            }
	        } else if ('dangerouslySetInnerHTML' === name) {
	            if (value) node.innerHTML = value.__html || '';
	        } else if ('o' == name[0] && 'n' == name[1]) {
	            var l = node._listeners || (node._listeners = {});
	            name = toLowerCase(name.substring(2));
	            if (value) {
	                if (!l[name]) node.addEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            } else if (l[name]) node.removeEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            l[name] = value;
	        } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
	            setProperty(node, name, null == value ? '' : value);
	            if (null == value || value === !1) node.removeAttribute(name);
	        } else {
	            var ns = isSvg && name.match(/^xlink\:?(.+)/);
	            if (null == value || value === !1) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1])); else node.removeAttribute(name); else if ('object' != typeof value && !isFunction(value)) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1]), value); else node.setAttribute(name, value);
	        }
	    }
	    function setProperty(node, name, value) {
	        try {
	            node[name] = value;
	        } catch (e) {}
	    }
	    function eventProxy(e) {
	        return this._listeners[e.type](options.event && options.event(e) || e);
	    }
	    function collectNode(node) {
	        removeNode(node);
	        if (node instanceof Element) {
	            node._component = node._componentConstructor = null;
	            var _name = node.normalizedNodeName || toLowerCase(node.nodeName);
	            (nodes[_name] || (nodes[_name] = [])).push(node);
	        }
	    }
	    function createNode(nodeName, isSvg) {
	        var name = toLowerCase(nodeName), node = nodes[name] && nodes[name].pop() || (isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName));
	        node.normalizedNodeName = name;
	        return node;
	    }
	    function flushMounts() {
	        var c;
	        while (c = mounts.pop()) {
	            if (options.afterMount) options.afterMount(c);
	            if (c.componentDidMount) c.componentDidMount();
	        }
	    }
	    function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	        if (!diffLevel++) {
	            isSvgMode = parent && void 0 !== parent.ownerSVGElement;
	            hydrating = dom && !(ATTR_KEY in dom);
	        }
	        var ret = idiff(dom, vnode, context, mountAll);
	        if (parent && ret.parentNode !== parent) parent.appendChild(ret);
	        if (!--diffLevel) {
	            hydrating = !1;
	            if (!componentRoot) flushMounts();
	        }
	        return ret;
	    }
	    function idiff(dom, vnode, context, mountAll) {
	        var ref = vnode && vnode.attributes && vnode.attributes.ref;
	        while (isFunctionalComponent(vnode)) vnode = buildFunctionalComponent(vnode, context);
	        if (null == vnode) vnode = '';
	        if (isString(vnode)) {
	            if (dom && dom instanceof Text && dom.parentNode) {
	                if (dom.nodeValue != vnode) dom.nodeValue = vnode;
	            } else {
	                if (dom) recollectNodeTree(dom);
	                dom = document.createTextNode(vnode);
	            }
	            return dom;
	        }
	        if (isFunction(vnode.nodeName)) return buildComponentFromVNode(dom, vnode, context, mountAll);
	        var out = dom, nodeName = String(vnode.nodeName), prevSvgMode = isSvgMode, vchildren = vnode.children;
	        isSvgMode = 'svg' === nodeName ? !0 : 'foreignObject' === nodeName ? !1 : isSvgMode;
	        if (!dom) out = createNode(nodeName, isSvgMode); else if (!isNamedNode(dom, nodeName)) {
	            out = createNode(nodeName, isSvgMode);
	            while (dom.firstChild) out.appendChild(dom.firstChild);
	            if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	            recollectNodeTree(dom);
	        }
	        var fc = out.firstChild, props = out[ATTR_KEY];
	        if (!props) {
	            out[ATTR_KEY] = props = {};
	            for (var a = out.attributes, i = a.length; i--; ) props[a[i].name] = a[i].value;
	        }
	        if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && fc && fc instanceof Text && !fc.nextSibling) {
	            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
	        } else if (vchildren && vchildren.length || fc) innerDiffNode(out, vchildren, context, mountAll, !!props.dangerouslySetInnerHTML);
	        diffAttributes(out, vnode.attributes, props);
	        if (ref) (props.ref = ref)(out);
	        isSvgMode = prevSvgMode;
	        return out;
	    }
	    function innerDiffNode(dom, vchildren, context, mountAll, absorb) {
	        var j, c, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren && vchildren.length;
	        if (len) for (var i = 0; i < len; i++) {
	            var _child = originalChildren[i], props = _child[ATTR_KEY], key = vlen ? (c = _child._component) ? c.__key : props ? props.key : null : null;
	            if (null != key) {
	                keyedLen++;
	                keyed[key] = _child;
	            } else if (hydrating || absorb || props || _child instanceof Text) children[childrenLen++] = _child;
	        }
	        if (vlen) for (var i = 0; i < vlen; i++) {
	            vchild = vchildren[i];
	            child = null;
	            var key = vchild.key;
	            if (null != key) {
	                if (keyedLen && key in keyed) {
	                    child = keyed[key];
	                    keyed[key] = void 0;
	                    keyedLen--;
	                }
	            } else if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) {
	                c = children[j];
	                if (c && isSameNodeType(c, vchild)) {
	                    child = c;
	                    children[j] = void 0;
	                    if (j === childrenLen - 1) childrenLen--;
	                    if (j === min) min++;
	                    break;
	                }
	            }
	            child = idiff(child, vchild, context, mountAll);
	            if (child && child !== dom) if (i >= len) dom.appendChild(child); else if (child !== originalChildren[i]) {
	                if (child === originalChildren[i + 1]) removeNode(originalChildren[i]);
	                dom.insertBefore(child, originalChildren[i] || null);
	            }
	        }
	        if (keyedLen) for (var i in keyed) if (keyed[i]) recollectNodeTree(keyed[i]);
	        while (min <= childrenLen) {
	            child = children[childrenLen--];
	            if (child) recollectNodeTree(child);
	        }
	    }
	    function recollectNodeTree(node, unmountOnly) {
	        var component = node._component;
	        if (component) unmountComponent(component, !unmountOnly); else {
	            if (node[ATTR_KEY] && node[ATTR_KEY].ref) node[ATTR_KEY].ref(null);
	            if (!unmountOnly) collectNode(node);
	            var c;
	            while (c = node.lastChild) recollectNodeTree(c, unmountOnly);
	        }
	    }
	    function diffAttributes(dom, attrs, old) {
	        var name;
	        for (name in old) if (!(attrs && name in attrs) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
	        if (attrs) for (name in attrs) if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
	    }
	    function collectComponent(component) {
	        var name = component.constructor.name, list = components[name];
	        if (list) list.push(component); else components[name] = [ component ];
	    }
	    function createComponent(Ctor, props, context) {
	        var inst = new Ctor(props, context), list = components[Ctor.name];
	        Component.call(inst, props, context);
	        if (list) for (var i = list.length; i--; ) if (list[i].constructor === Ctor) {
	            inst.nextBase = list[i].nextBase;
	            list.splice(i, 1);
	            break;
	        }
	        return inst;
	    }
	    function setComponentProps(component, props, opts, context, mountAll) {
	        if (!component._disable) {
	            component._disable = !0;
	            if (component.__ref = props.ref) delete props.ref;
	            if (component.__key = props.key) delete props.key;
	            if (!component.base || mountAll) {
	                if (component.componentWillMount) component.componentWillMount();
	            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
	            if (context && context !== component.context) {
	                if (!component.prevContext) component.prevContext = component.context;
	                component.context = context;
	            }
	            if (!component.prevProps) component.prevProps = component.props;
	            component.props = props;
	            component._disable = !1;
	            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !component.base) renderComponent(component, 1, mountAll); else enqueueRender(component);
	            if (component.__ref) component.__ref(component);
	        }
	    }
	    function renderComponent(component, opts, mountAll, isChild) {
	        if (!component._disable) {
	            var skip, rendered, inst, cbase, props = component.props, state = component.state, context = component.context, previousProps = component.prevProps || props, previousState = component.prevState || state, previousContext = component.prevContext || context, isUpdate = component.base, nextBase = component.nextBase, initialBase = isUpdate || nextBase, initialChildComponent = component._component;
	            if (isUpdate) {
	                component.props = previousProps;
	                component.state = previousState;
	                component.context = previousContext;
	                if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
	                component.props = props;
	                component.state = state;
	                component.context = context;
	            }
	            component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	            component._dirty = !1;
	            if (!skip) {
	                if (component.render) rendered = component.render(props, state, context);
	                if (component.getChildContext) context = extend(clone(context), component.getChildContext());
	                while (isFunctionalComponent(rendered)) rendered = buildFunctionalComponent(rendered, context);
	                var toUnmount, base, childComponent = rendered && rendered.nodeName;
	                if (isFunction(childComponent)) {
	                    var childProps = getNodeProps(rendered);
	                    inst = initialChildComponent;
	                    if (inst && inst.constructor === childComponent && childProps.key == inst.__key) setComponentProps(inst, childProps, 1, context); else {
	                        toUnmount = inst;
	                        inst = createComponent(childComponent, childProps, context);
	                        inst.nextBase = inst.nextBase || nextBase;
	                        inst._parentComponent = component;
	                        component._component = inst;
	                        setComponentProps(inst, childProps, 0, context);
	                        renderComponent(inst, 1, mountAll, !0);
	                    }
	                    base = inst.base;
	                } else {
	                    cbase = initialBase;
	                    toUnmount = initialChildComponent;
	                    if (toUnmount) cbase = component._component = null;
	                    if (initialBase || 1 === opts) {
	                        if (cbase) cbase._component = null;
	                        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
	                    }
	                }
	                if (initialBase && base !== initialBase && inst !== initialChildComponent) {
	                    var baseParent = initialBase.parentNode;
	                    if (baseParent && base !== baseParent) {
	                        baseParent.replaceChild(base, initialBase);
	                        if (!toUnmount) {
	                            initialBase._component = null;
	                            recollectNodeTree(initialBase);
	                        }
	                    }
	                }
	                if (toUnmount) unmountComponent(toUnmount, base !== initialBase);
	                component.base = base;
	                if (base && !isChild) {
	                    var componentRef = component, t = component;
	                    while (t = t._parentComponent) (componentRef = t).base = base;
	                    base._component = componentRef;
	                    base._componentConstructor = componentRef.constructor;
	                }
	            }
	            if (!isUpdate || mountAll) mounts.unshift(component); else if (!skip) {
	                if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
	                if (options.afterUpdate) options.afterUpdate(component);
	            }
	            var fn, cb = component._renderCallbacks;
	            if (cb) while (fn = cb.pop()) fn.call(component);
	            if (!diffLevel && !isChild) flushMounts();
	        }
	    }
	    function buildComponentFromVNode(dom, vnode, context, mountAll) {
	        var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
	        while (c && !isOwner && (c = c._parentComponent)) isOwner = c.constructor === vnode.nodeName;
	        if (c && isOwner && (!mountAll || c._component)) {
	            setComponentProps(c, props, 3, context, mountAll);
	            dom = c.base;
	        } else {
	            if (originalComponent && !isDirectOwner) {
	                unmountComponent(originalComponent, !0);
	                dom = oldDom = null;
	            }
	            c = createComponent(vnode.nodeName, props, context);
	            if (dom && !c.nextBase) {
	                c.nextBase = dom;
	                oldDom = null;
	            }
	            setComponentProps(c, props, 1, context, mountAll);
	            dom = c.base;
	            if (oldDom && dom !== oldDom) {
	                oldDom._component = null;
	                recollectNodeTree(oldDom);
	            }
	        }
	        return dom;
	    }
	    function unmountComponent(component, remove) {
	        if (options.beforeUnmount) options.beforeUnmount(component);
	        var base = component.base;
	        component._disable = !0;
	        if (component.componentWillUnmount) component.componentWillUnmount();
	        component.base = null;
	        var inner = component._component;
	        if (inner) unmountComponent(inner, remove); else if (base) {
	            if (base[ATTR_KEY] && base[ATTR_KEY].ref) base[ATTR_KEY].ref(null);
	            component.nextBase = base;
	            if (remove) {
	                removeNode(base);
	                collectComponent(component);
	            }
	            var c;
	            while (c = base.lastChild) recollectNodeTree(c, !remove);
	        }
	        if (component.__ref) component.__ref(null);
	        if (component.componentDidUnmount) component.componentDidUnmount();
	    }
	    function Component(props, context) {
	        this._dirty = !0;
	        this.context = context;
	        this.props = props;
	        if (!this.state) this.state = {};
	    }
	    function render(vnode, parent, merge) {
	        return diff(merge, vnode, {}, !1, parent);
	    }
	    var options = {};
	    var stack = [];
	    var EMPTY_CHILDREN = [];
	    var lcCache = {};
	    var toLowerCase = function(s) {
	        return lcCache[s] || (lcCache[s] = s.toLowerCase());
	    };
	    var resolved = 'undefined' != typeof Promise && Promise.resolve();
	    var defer = resolved ? function(f) {
	        resolved.then(f);
	    } : setTimeout;
	    var EMPTY = {};
	    var ATTR_KEY = 'undefined' != typeof Symbol ? Symbol.for('preactattr') : '__preactattr_';
	    var NON_DIMENSION_PROPS = {
	        boxFlex: 1,
	        boxFlexGroup: 1,
	        columnCount: 1,
	        fillOpacity: 1,
	        flex: 1,
	        flexGrow: 1,
	        flexPositive: 1,
	        flexShrink: 1,
	        flexNegative: 1,
	        fontWeight: 1,
	        lineClamp: 1,
	        lineHeight: 1,
	        opacity: 1,
	        order: 1,
	        orphans: 1,
	        strokeOpacity: 1,
	        widows: 1,
	        zIndex: 1,
	        zoom: 1
	    };
	    var NON_BUBBLING_EVENTS = {
	        blur: 1,
	        error: 1,
	        focus: 1,
	        load: 1,
	        resize: 1,
	        scroll: 1
	    };
	    var items = [];
	    var nodes = {};
	    var mounts = [];
	    var diffLevel = 0;
	    var isSvgMode = !1;
	    var hydrating = !1;
	    var components = {};
	    extend(Component.prototype, {
	        linkState: function(key, eventPath) {
	            var c = this._linkedStates || (this._linkedStates = {});
	            return c[key + eventPath] || (c[key + eventPath] = createLinkedState(this, key, eventPath));
	        },
	        setState: function(state, callback) {
	            var s = this.state;
	            if (!this.prevState) this.prevState = clone(s);
	            extend(s, isFunction(state) ? state(s, this.props) : state);
	            if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
	            enqueueRender(this);
	        },
	        forceUpdate: function() {
	            renderComponent(this, 2);
	        },
	        render: function() {}
	    });
	    exports.h = h;
	    exports.cloneElement = cloneElement;
	    exports.Component = Component;
	    exports.render = render;
	    exports.rerender = rerender;
	    exports.options = options;
	});
	//# sourceMappingURL=preact.js.map

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var desktopWrapperStyle = exports.desktopWrapperStyle = {
	    position: 'fixed',
	    bottom: '20px',
	    right: '20px',
	    zIndex: 2147483647,
	    borderRadius: '10px',
	    background: 'rgb(229, 229, 229)',
	    boxSizing: 'content-box',
	    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.5)',
	    overflow: 'hidden'
	};
	
	var desktopClosedWrapperStyleChat = exports.desktopClosedWrapperStyleChat = {
	    position: 'fixed',
	    bottom: '0px',
	    right: '0px',
	    zIndex: 2147483647,
	    minWidth: '400px',
	    boxSizing: 'content-box',
	    overflow: 'hidden',
	    minHeight: '120px'
	};
	
	var mobileClosedWrapperStyle = exports.mobileClosedWrapperStyle = {
	    position: 'fixed',
	    bottom: 18,
	    right: 18,
	    zIndex: 2147483647,
	    borderRadius: '50%',
	    background: 'rgb(229, 229, 229)',
	    boxSizing: 'content-box'
	};
	
	var mobileOpenWrapperStyle = exports.mobileOpenWrapperStyle = {
	    position: 'fixed',
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0,
	    zIndex: 2147483647,
	    width: '100%',
	    height: '100%',
	    background: 'rgb(229, 229, 229)',
	    overflowY: 'visible',
	    boxSizing: 'content-box'
	};
	
	var desktopTitleStyle = exports.desktopTitleStyle = {
	    height: '40px',
	    lineHeight: '30px',
	    fontSize: '20px',
	    display: 'flex',
	    justifyContent: 'space-between',
	    padding: '5px 0 5px 20px',
	    fontFamily: 'Lato, sans-serif',
	    color: '#fff',
	    cursor: 'pointer'
	};
	
	var mobileTitleStyle = exports.mobileTitleStyle = {
	    height: 52,
	    width: 52,
	    cursor: 'pointer',
	    borderRadius: '50%',
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    webkitBoxShadow: '1px 1px 4px rgba(101,119,134,.75)',
	    boxShadow: '1px 1px 4px rgba(101,119,134,.75)'
	};

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArrowIcon = function (_Component) {
	    _inherits(ArrowIcon, _Component);
	
	    function ArrowIcon() {
	        _classCallCheck(this, ArrowIcon);
	
	        return _possibleConstructorReturn(this, (ArrowIcon.__proto__ || Object.getPrototypeOf(ArrowIcon)).apply(this, arguments));
	    }
	
	    _createClass(ArrowIcon, [{
	        key: 'render',
	        value: function render(_ref, _ref2) {
	            var isOpened = _ref.isOpened;
	
	            _objectDestructuringEmpty(_ref2);
	
	            return (0, _preact.h)(
	                'div',
	                null,
	                isOpened ? (0, _preact.h)(
	                    'svg',
	                    { style: {
	                            marginRight: 15,
	                            marginTop: 6,
	                            verticalAlign: 'middle'
	                        },
	                        fill: '#FFFFFF', height: '15', viewBox: '0 0 15 15', width: '15',
	                        xmlns: 'http://www.w3.org/2000/svg' },
	                    (0, _preact.h)('line', { x1: '1', y1: '15',
	                        x2: '15', y2: '1',
	                        stroke: 'white',
	                        'stroke-width': '1' }),
	                    (0, _preact.h)('line', { x1: '1', y1: '1',
	                        x2: '15', y2: '15',
	                        stroke: 'white',
	                        'stroke-width': '1' })
	                ) : (0, _preact.h)(
	                    'svg',
	                    { style: {
	                            marginRight: 15,
	                            marginTop: 6,
	                            verticalAlign: 'middle'
	                        },
	                        fill: '#FFFFFF', height: '24', viewBox: '0 0 24 24', width: '24',
	                        xmlns: 'http://www.w3.org/2000/svg' },
	                    (0, _preact.h)('path', { d: 'M2.582 13.891c-0.272 0.268-0.709 0.268-0.979 0s-0.271-0.701 0-0.969l7.908-7.83c0.27-0.268 0.707-0.268 0.979 0l7.908 7.83c0.27 0.268 0.27 0.701 0 0.969s-0.709 0.268-0.978 0l-7.42-7.141-7.418 7.141z' })
	                )
	            );
	        }
	    }]);
	
	    return ArrowIcon;
	}(_preact.Component);
	
	exports.default = ArrowIcon;

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	var _style = __webpack_require__(11);
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatFloatingButton = function (_Component) {
	    _inherits(ChatFloatingButton, _Component);
	
	    function ChatFloatingButton() {
	        _classCallCheck(this, ChatFloatingButton);
	
	        return _possibleConstructorReturn(this, (ChatFloatingButton.__proto__ || Object.getPrototypeOf(ChatFloatingButton)).apply(this, arguments));
	    }
	
	    _createClass(ChatFloatingButton, [{
	        key: "render",
	        value: function render(_ref, _ref2) {
	            var color = _ref.color,
	                onClick = _ref.onClick;
	
	            _objectDestructuringEmpty(_ref2);
	
	            return (0, _preact.h)(
	                "div",
	                {
	                    style: _extends({ background: color }, _style.mobileTitleStyle),
	                    onClick: onClick },
	                (0, _preact.h)(
	                    "svg",
	                    { style: { paddingTop: 4 },
	                        fill: "#FFFFFF", height: "24", viewBox: "0 0 24 24", width: "24",
	                        xmlns: "http://www.w3.org/2000/svg" },
	                    (0, _preact.h)("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" }),
	                    (0, _preact.h)("path", { d: "M0 0h24v24H0z", fill: "none" })
	                )
	            );
	        }
	    }]);
	
	    return ChatFloatingButton;
	}(_preact.Component);
	
	exports.default = ChatFloatingButton;

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatFrame = function (_Component) {
	    _inherits(ChatFrame, _Component);
	
	    function ChatFrame() {
	        _classCallCheck(this, ChatFrame);
	
	        return _possibleConstructorReturn(this, (ChatFrame.__proto__ || Object.getPrototypeOf(ChatFrame)).apply(this, arguments));
	    }
	
	    _createClass(ChatFrame, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            // do not re-render via diff:
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref, _ref2) {
	            var intergramId = _ref.intergramId,
	                host = _ref.host,
	                iFrameSrc = _ref.iFrameSrc,
	                isMobile = _ref.isMobile,
	                conf = _ref.conf;
	
	            _objectDestructuringEmpty(_ref2);
	
	            var dynamicConf = window.intergramOnOpen || {}; // these configuration are loaded when the chat frame is opened
	            var encodedConf = encodeURIComponent(JSON.stringify(_extends({}, conf, dynamicConf)));
	            return (0, _preact.h)('iframe', { src: iFrameSrc + '?id=' + intergramId + '&host=' + host + '&conf=' + encodedConf,
	                width: '100%',
	                height: isMobile ? '94%' : '100%',
	                frameborder: '0' });
	        }
	    }]);
	
	    return ChatFrame;
	}(_preact.Component);
	
	exports.default = ChatFrame;

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatTitleMsg = function (_Component) {
	    _inherits(ChatTitleMsg, _Component);
	
	    function ChatTitleMsg() {
	        _classCallCheck(this, ChatTitleMsg);
	
	        return _possibleConstructorReturn(this, (ChatTitleMsg.__proto__ || Object.getPrototypeOf(ChatTitleMsg)).apply(this, arguments));
	    }
	
	    _createClass(ChatTitleMsg, [{
	        key: 'render',
	        value: function render(_ref, _ref2) {
	            var isOpened = _ref.isOpened,
	                conf = _ref.conf;
	
	            _objectDestructuringEmpty(_ref2);
	
	            return (0, _preact.h)(
	                'div',
	                { style: { position: 'relative', cursor: 'pointer' }, onClick: this.props.onClick },
	                (0, _preact.h)(
	                    'div',
	                    {
	                        className: 'desktop-closed-message',
	                        style: {
	                            background: conf.mainColor,
	                            letterSpacing: '1px',
	                            color: '#fff',
	                            display: 'block',
	                            position: 'absolute',
	                            fontSize: '14px',
	                            top: 0,
	                            right: '130px',
	                            marginTop: '23px',
	                            borderRadius: '5px',
	                            padding: '15px 20px',
	                            boxShadow: '#8e8d8d -3px 2px 20px'
	                        }
	                    },
	                    conf.introMessage,
	                    (0, _preact.h)('div', {
	                        style: {
	                            width: 0,
	                            height: 0,
	                            position: 'absolute',
	                            top: '12px',
	                            right: '-10px',
	                            borderTop: '10px solid transparent',
	                            borderBottom: '10px solid transparent',
	                            borderLeft: '10px solid ' + conf.mainColor
	                        }
	                    })
	                ),
	                (0, _preact.h)(
	                    'div',
	                    {
	                        className: 'desktop-closed-message-avatar',
	                        style: {
	                            background: '#fff',
	                            display: 'block',
	                            position: 'absolute',
	                            top: '10px',
	                            right: '40px',
	                            height: '60px',
	                            width: '60px',
	                            borderRadius: '999px',
	                            boxShadow: '#8e8d8d -3px 2px 20px',
	                            border: '2px solid ' + conf.mainColor
	                        }
	                    },
	                    conf.closedChatAvatarUrl === '' ? (0, _preact.h)(
	                        'svg',
	                        { style: {
	                                width: '100%',
	                                height: 'auto',
	                                borderRadius: '999px'
	                            },
	                            fill: '#000000', height: '24', viewBox: '0 0 24 24', width: '24',
	                            xmlns: 'http://www.w3.org/2000/svg' },
	                        (0, _preact.h)('path', { d: 'M20 21.859c0 2.281-1.5 4.141-3.328 4.141h-13.344c-1.828 0-3.328-1.859-3.328-4.141 0-4.109 1.016-8.859 5.109-8.859 1.266 1.234 2.984 2 4.891 2s3.625-0.766 4.891-2c4.094 0 5.109 4.75 5.109 8.859zM16 8c0 3.313-2.688 6-6 6s-6-2.688-6-6 2.688-6 6-6 6 2.688 6 6z' })
	                    ) : (0, _preact.h)('img', {
	                        src: conf.closedChatAvatarUrl,
	                        alt: 'Avatar',
	                        style: {
	                            width: '100%',
	                            height: 'auto',
	                            borderRadius: '999px'
	                        }
	                    }),
	                    (0, _preact.h)(
	                        'div',
	                        {
	                            style: {
	                                background: '#d0021b',
	                                width: '20px',
	                                height: '20px',
	                                borderRadius: '999px',
	                                position: 'absolute',
	                                right: '-5px',
	                                bottom: '-5px',
	                                textAlign: 'center',
	                                color: '#fff',
	                                fontWeight: 600,
	                                fontSize: '0.8em',
	                                lineHeight: '20px'
	                            }
	                        },
	                        '1'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChatTitleMsg;
	}(_preact.Component);
	
	exports.default = ChatTitleMsg;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var defaultConfiguration = exports.defaultConfiguration = {
	    titleClosed: '点击聊天！',
	    titleOpen: '我们聊聊吧！',
	    closedStyle: 'chat', // button or chat
	    closedChatAvatarUrl: '', // only used if closedStyle is set to 'chat'
	    cookieExpiration: 1, // in days. Once opened, closed chat title will be shown as button (when closedStyle is set to 'chat')
	    introMessage: '你好我们能为您做些什么？',
	    autoResponse: '我们支持 24 小时在线服务哦',
	    autoNoResponse: 'It seems that no one is available to answer right now. Please tell us how we can ' + 'contact you, and we will get back to you as soon as we can.',
	    placeholderText: '发送消息...',
	    displayMessageTime: true,
	    mainColor: '#1f8ceb',
	    alwaysUseFloatingButton: false,
	    desktopHeight: 450,
	    desktopWidth: 370,
	    visitorPronoun: '你',
	    adminPronoun: "客服"
	};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _preact = __webpack_require__(1);
	
	var _widget = __webpack_require__(38);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	var _defaultConfiguration = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (window.attachEvent) {
	    window.attachEvent('onload', injectChat);
	} else {
	    window.addEventListener('load', injectChat, false);
	}
	
	function injectChat() {
	    if (!window.intergramId) {
	        console.error('Please set window.intergramId (see example at github.com/idoco/intergram)');
	    } else {
	        var root = document.createElement('div');
	        root.id = 'intergramRoot';
	        document.getElementsByTagName('body')[0].appendChild(root);
	        var server = window.intergramServer || 'https://www.intergram.xyz';
	        var iFrameSrc = server + '/chat.html';
	        var host = window.location.host || 'unknown-host';
	        var conf = _extends({}, _defaultConfiguration.defaultConfiguration, window.intergramCustomizations);
	
	        (0, _preact.render)((0, _preact.h)(_widget2.default, { intergramId: window.intergramId,
	            host: host,
	            isMobile: window.screen.width < 500,
	            iFrameSrc: iFrameSrc,
	            conf: conf
	        }), root);
	
	        try {
	            var request = new XMLHttpRequest();
	            request.open('POST', server + '/usage-start?host=' + host);
	            request.send();
	        } catch (e) {/* Fail silently */}
	    }
	}

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(1);
	
	var _chatFrame = __webpack_require__(34);
	
	var _chatFrame2 = _interopRequireDefault(_chatFrame);
	
	var _chatFloatingButton = __webpack_require__(33);
	
	var _chatFloatingButton2 = _interopRequireDefault(_chatFloatingButton);
	
	var _chatTitleMsg = __webpack_require__(35);
	
	var _chatTitleMsg2 = _interopRequireDefault(_chatTitleMsg);
	
	var _arrowIcon = __webpack_require__(32);
	
	var _arrowIcon2 = _interopRequireDefault(_arrowIcon);
	
	var _style = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Widget = function (_Component) {
	    _inherits(Widget, _Component);
	
	    function Widget() {
	        _classCallCheck(this, Widget);
	
	        var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this));
	
	        _this.onClick = function () {
	            var stateData = {
	                pristine: false,
	                isChatOpen: !_this.state.isChatOpen
	            };
	            if (!_this.state.isChatOpen && !_this.wasChatOpened()) {
	                _this.setCookie();
	                stateData.wasChatOpened = true;
	            }
	            _this.setState(stateData);
	        };
	
	        _this.setCookie = function () {
	            var date = new Date();
	            var expirationTime = parseInt(_this.props.conf.cookieExpiration);
	            date.setTime(date.getTime() + expirationTime * 24 * 60 * 60 * 1000);
	            var expires = "; expires=" + date.toGMTString();
	            document.cookie = "chatwasopened=1" + expires + "; path=/";
	        };
	
	        _this.getCookie = function () {
	            var nameEQ = "chatwasopened=";
	            var ca = document.cookie.split(';');
	            for (var i = 0; i < ca.length; i++) {
	                var c = ca[i];
	                while (c.charAt(0) == ' ') {
	                    c = c.substring(1, c.length);
	                }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	            }
	            return false;
	        };
	
	        _this.wasChatOpened = function () {
	            return _this.getCookie() === false ? false : true;
	        };
	
	        _this.state.isChatOpen = false;
	        _this.state.pristine = true;
	        _this.state.wasChatOpened = _this.wasChatOpened();
	        return _this;
	    }
	
	    _createClass(Widget, [{
	        key: 'render',
	        value: function render(_ref, _ref2) {
	            var conf = _ref.conf,
	                isMobile = _ref.isMobile;
	            var isChatOpen = _ref2.isChatOpen,
	                pristine = _ref2.pristine;
	
	
	            var wrapperWidth = { width: conf.desktopWidth };
	            var desktopHeight = window.innerHeight - 100 < conf.desktopHeight ? window.innerHeight - 90 : conf.desktopHeight;
	            var wrapperHeight = { height: desktopHeight };
	
	            var wrapperStyle = void 0;
	            if (!isChatOpen && (isMobile || conf.alwaysUseFloatingButton)) {
	                wrapperStyle = _extends({}, _style.mobileClosedWrapperStyle); // closed mobile floating button
	            } else if (!isMobile) {
	                wrapperStyle = conf.closedStyle === 'chat' || isChatOpen || this.wasChatOpened() ? isChatOpen ? _extends({}, _style.desktopWrapperStyle, wrapperWidth) // desktop mode, button style
	                : _extends({}, _style.desktopWrapperStyle) : _extends({}, _style.desktopClosedWrapperStyleChat); // desktop mode, chat style
	            } else {
	                wrapperStyle = _style.mobileOpenWrapperStyle; // open mobile wrapper should have no border
	            }
	
	            return (0, _preact.h)(
	                'div',
	                { style: wrapperStyle },
	                (isMobile || conf.alwaysUseFloatingButton) && !isChatOpen ? (0, _preact.h)(_chatFloatingButton2.default, { color: conf.mainColor, onClick: this.onClick }) : conf.closedStyle === 'chat' || isChatOpen || this.wasChatOpened() ? (0, _preact.h)(
	                    'div',
	                    { style: _extends({ background: conf.mainColor }, _style.desktopTitleStyle), onClick: this.onClick },
	                    (0, _preact.h)(
	                        'div',
	                        { style: { display: 'flex', alignItems: 'center', padding: '0px 30px 0px 0px' } },
	                        isChatOpen ? conf.titleOpen : conf.titleClosed
	                    ),
	                    (0, _preact.h)(_arrowIcon2.default, { isOpened: isChatOpen })
	                ) : (0, _preact.h)(_chatTitleMsg2.default, { onClick: this.onClick, conf: conf }),
	                (0, _preact.h)(
	                    'div',
	                    { style: {
	                            display: isChatOpen ? 'block' : 'none',
	                            height: isMobile ? '100%' : desktopHeight
	                        } },
	                    pristine ? null : (0, _preact.h)(_chatFrame2.default, this.props)
	                )
	            );
	        }
	    }]);
	
	    return Widget;
	}(_preact.Component);
	
	exports.default = Widget;

/***/ })

/******/ });


// WEBPACK FOOTER //
// widget.js